exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);", ""]);

// module
exports.push([module.id, ".ui.grid.nav-grid {\n  margin-top: 3rem;\n}\n.ui.menu.main-menu .item {\n  text-transform: uppercase;\n  font-weight: 700;\n  font-family: 'Montserrat', sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/common/components/Nav.less
// module id = 959
// module chunks = 0